import { ProfileContext } from '../../../contexts/ProfileContext';
import React, { useContext } from 'react';
import ZdarStopWatch from './ZdarStopWatch';

type Props = {
    image?: number;
};

export default function ZdarHeader({ image }: Props) {
    const { availableGame } = useContext(ProfileContext);
    if (availableGame) {
        return <div className="zdar-header">{availableGame.started !== null && <ZdarStopWatch image={image} />}</div>;
    }
    return <React.Fragment />;
}
